import {z} from 'zod';

export const PostMazdaPortalLoginApiResponseSchema = z
  .object({
    redirectUrl: z.string().nullable().optional(),
  })
  .nullable();

export type PostMazdaPortalLoginApiResponse = z.infer<typeof PostMazdaPortalLoginApiResponseSchema>;

export const PostMazdaPortalLoginApiArgSchema = z.object({
  authorizationProfileId: z.string(),
  destination: z.string(),
});

export type PostMazdaPortalLoginApiArg = z.infer<typeof PostMazdaPortalLoginApiArgSchema>;
